/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 企業の管理画面用 API
 * PR TIMES 企業の管理画面で使うAPI。basePathは今後変わる事も想定している。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * プレスキットタグの詳細
 * @export
 * @interface PressKitTag
 */
export interface PressKitTag {
    /**
     * PressKit Tag UUID(v4)
     * @type {string}
     * @memberof PressKitTag
     */
    id: string;
    /**
     * UI上で表示されるタグの名前
     * @type {string}
     * @memberof PressKitTag
     */
    name: string;
}

/**
 * Check if a given object implements the PressKitTag interface.
 */
export function instanceOfPressKitTag(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function PressKitTagFromJSON(json: any): PressKitTag {
    return PressKitTagFromJSONTyped(json, false);
}

export function PressKitTagFromJSONTyped(json: any, ignoreDiscriminator: boolean): PressKitTag {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function PressKitTagToJSON(value?: PressKitTag | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}

